import React, { useState } from "react";
import OnboardLayout from "../../components/layout-components/OnboardLayout";
import { Button, Grid } from "@mui/material";
import CustomInput from "../../components/CustomInput";
import { useNavigate } from "react-router-dom";
import { activateUserAccount } from "../../services/CompanyService";
import CommonUtil from "../../util/CommonUtils";
import { ReactComponent as VisibilityIcon } from "../../assets/images/icon_viewoff.svg";
import { ReactComponent as VisibilityOffIcon } from "../../assets/images/icon_viewon.svg";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
export default function ActivateAccount() {
  const [visibility, setVisibility] = useState(true);
  const [confirmVisibility, setConfirmVisibility] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const navigate = useNavigate();
  var urlValue = window.location.href;
  var url = new URL(urlValue);
  var userIdentifierData = url.searchParams.get("e");
  var idData = url.searchParams.get("t");
  var companyCodeData = url.searchParams.get("c");

  const [payload, setPayload] = useState({
    id: "",
    password: "",
    confirmPassword: "",
    userIdentifier: "",
    companyCode: "",
  });

  const [error, setError] = useState({
    id: "",
    password: "",
    confirmPassword: "",
    userIdentifier: "",
    companyCode: "",
  });
  const handleSubmit = () => {
    if (validatePayload()) {
      var state = {
        ...payload,
        userIdentifier: userIdentifierData,
        id: idData,
        companyCode: companyCodeData,
      };
      activateUserAccount(state).then((response) => {
        if (response.data.code === "LVLI0012") {
          enqueueSnackbar(response.data.message, {
            variant: "success",
            anchorOrigin: {
              horizontal: "center",
              vertical: "top",
            },
            style: {
              marginTop: "300px",
            },
          });
          navigate("/");
        } else enqueueSnackbar(response.data.message, { variant: "error" });
      });
    }
  };

  const validatePayload = () => {
    if (CommonUtil.isEmpty(payload.password)) {
      setError({
        ...error,
        password: t("common.common_password_enter"),
      });
      return false;
    }

    if (!CommonUtil.isValidPassword(payload.password)) {
      setError({
        ...error,
        password: t("tips.password_title"),
      });
      return false;
    }

    if (payload.password !== payload.confirmPassword) {
      setError({
        ...error,
        confirmPassword: t("common.common_mismatched"),
      });
      return false;
    }
    return true;
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
    setError({
      ...error,
      [name]: "",
    });
  };
  return (
    <Grid container sx={{ display: "flex", width: "auto", height: "100vh" }}>
      <OnboardLayout label={t("common.set_password")}>
        <Grid
          sx={{
            display: "flex",
            width: "450px",
            height: "120px",
            opacity: "1",
            flexWrap: "wrap",
          }}
        >
          <CustomInput
            id="ActivateAccount-01"
            required
            label={t("common.new_password")}
            size="small"
            name="password"
            placeholder={t("common.new_password")}
            error={error.password}
            resetError={() => setError({ ...error, password: "" })}
            helperText={error.password}
            handleChange={handleChange}
            validation={"password"}
            type={visibility ? "password" : "text"}
            autoComplete="off"
            InputProps={{
              endAdornment: visibility ? (
                <VisibilityOffIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setVisibility(!visibility);
                  }}
                />
              ) : (
                <VisibilityIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setVisibility(!visibility);
                  }}
                />
              ),
            }}
          />
        </Grid>
        <Grid
          sx={{
            flexWrap: "wrap",
            justifyContent: "flex-start",
            alignContent: "center",
            pb: 2,
            borderRadius: "8px 0px 0px 8px",
          }}
        >
          <CustomInput
            id="ActivateAccount-02"
            required
            label={t("common.confirm_password")}
            size="small"
            name="confirmPassword"
            placeholder={t("common.confirm_password")}
            error={error.confirmPassword}
            resetError={() => setError({ ...error, confirmPassword: "" })}
            helperText={error.confirmPassword}
            handleChange={handleChange}
            type={confirmVisibility ? "password" : "text"}
            autoComplete="off"
            InputProps={{
              endAdornment: confirmVisibility ? (
                <VisibilityOffIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setConfirmVisibility(!confirmVisibility);
                  }}
                />
              ) : (
                <VisibilityIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setConfirmVisibility(!confirmVisibility);
                  }}
                />
              ),
            }}
          />
        </Grid>
        <Grid
          sx={{
            flexWrap: "wrap",
            justifyContent: "flex-start",
            alignContent: "center",
            pt: 1,
            pb: 0.5,
          }}
        >
          <Button
            fullWidth
            onClick={() => handleSubmit()}
            sx={{
              background:
                "transparent linear-gradient(270deg, #1487CA 0%, #78BC27 100%) 0% 0% no-repeat padding-box",
              borderRadius: "8px",
              opacity: "1",
              font: "normal normal normal 16px/28px Roboto",
              color: "#FFFFFF",
            }}
          >
            {" "}
            {t("common.submit")}{" "}
          </Button>
        </Grid>
      </OnboardLayout>
    </Grid>
  );
}
